/**
 * Brazilian Portuguese (pt-BR) mappings for MobileSlideOverMenu
 */

export const mobileSlideOverMenuPtBR = {
  // Sport categories
  "Available Now": "Disponível Agora",
  "Chat Only": "Apenas Chat",
  "Coming Soon": "Em Breve",
  "soon": "em breve",
  
  // Menu items
  "AI Toolkit": "Kit de IA",
  "Pick Slip": "Bilhete de Apostas",
  "Team Explorer": "Explorador de Times",
  "Game Explorer": "Explorador de Jogos",
  "Live Sports": "Esportes Ao Vivo",
  "Response Mode": "Modo de Resposta",
  "Chat History": "Histórico de Chat",
  "New Chat": "Nova Conversa",
  
  // Response modes
  "Balanced Response": "Resposta Equilibrada",
  "Quick & Concise": "Rápido e Conciso",
  "Expert Analysis": "Análise Especializada",
  "Standard detail and context": "Detalhes e contexto padrão",
  "Short, direct answers": "Respostas curtas e diretas",
  "Comprehensive & detailed insights": "Insights abrangentes e detalhados",
  "Standard": "Padrão",
  "Quick": "Rápido",
  "Detailed": "Detalhado",
  
  // AI Toolkit tabs
  "My Prompts": "Meus Prompts",
  "Popular Picks": "Apostas Populares",
  "Advanced Analysis": "Análise Avançada",
  
  // Pick Slip
  "My Picks": "Minhas Apostas",
  "No picks saved yet": "Nenhuma aposta salva ainda",
  "Select text and click \"Add to Pick Slip\"": "Selecione o texto e clique em \"Adicionar ao Bilhete\"",
  "Add Pick": "Adicionar Aposta",
  "Clear All": "Limpar Tudo",
  "Copy All Picks": "Copiar Todas as Apostas",
  
  // Dialogs
  "Delete this pick?": "Excluir esta aposta?",
  "Are you sure you want to remove this pick from your list?": "Tem certeza de que deseja remover esta aposta da sua lista?",
  "Clear all picks?": "Limpar todas as apostas?",
  "Are you sure you want to remove all picks from your list?": "Tem certeza de que deseja remover todas as apostas da sua lista?",
  "Add Custom Pick": "Adicionar Aposta Personalizada",
  "Enter your pick details...": "Digite os detalhes da sua aposta...",
  "Cancel": "Cancelar",
  "Delete": "Excluir",
  
  // Toast messages
  "Ask PickStar AI about {sport} games, insights, and predictions in chat!": "Pergunte ao PickStar AI sobre jogos, insights e previsões de {sport} no chat!",
  "{sport} features coming soon! Stay tuned for updates.": "Recursos de {sport} em breve! Fique ligado nas atualizações.",
  "Picks copied to clipboard!": "Apostas copiadas para a área de transferência!",
  
  // Sport names
  "MLB": "MLB",
  "NBA": "NBA", 
  "NHL": "NHL",
  "NCAAB": "NCAAB",
  "NFL": "NFL",
  "Soccer": "Futebol",
  "Tennis": "Tênis",
  "Golf": "Golfe",
  
  // General UI
  "Select a sport to explore teams, stats, and insights": "Selecione um esporte para explorar times, estatísticas e insights",
  "Close": "Fechar",
  
  // Chat Mode prefix
  "Chat Mode:": "Modo de Chat:",
  
  // Additional Menu items
  "PickStar Tools": "Ferramentas PickStar",
  "Access powerful features and insights": "Acesse recursos poderosos e insights",
  "My Tools": "Minhas Ferramentas",
  "Actions": "Ações",
  "Chat Available": "Chat Disponível",
  "Ask questions about these sports in chat": "Faça perguntas sobre esses esportes no chat",
  "Use AI-powered suggestions and custom prompts": "Use sugestões baseadas em IA e prompts personalizados",
  "Popular Suggestions": "Sugestões Populares",
  "Soccer Analysis": "Análise de Futebol",
  "Choose how PickStar responds to your questions": "Escolha como o PickStar responde às suas perguntas",
  "Advanced": "Avançado"
};